/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================== Earth ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';

window._klvReady = window._klvReady || [];
window._klvReady.push(function() {
    window.klevu.interactive(function() {
klevu({
  theme: {
      setHelpers: {
          "all": {
              namePrettifier: function (name) {
                  return name.replace(/[\[\]"]/g, '');
              }
          }
      }
  }
});

});

/**
 * Gift Card Exclusion for Non-UK Storefronts
 *
 * The Digital Gift Card product is only available in the UK market.
 * Klevu shares a single API key across all storefronts (Shopify locale setup),
 * so we exclude the gift card product IDs from search results on non-UK storefronts.
 *
 * itemGroupId = Shopify Product ID:
 * - 5088208093316 (Borough Kitchen Digital Gift Card)
 * - 5090435006596 (Borough Kitchen Paper Gift Card)
 */
var GIFT_CARD_EXCLUDE_IDS = [
    { key: 'itemGroupId', value: '5088208093316' },
    { key: 'itemGroupId', value: '5090435006596' }
];

function isNonUKStorefront() {
    var currentCountry = window.theme?.country;

    // If country is not set, check URL path for locale prefix
    if (!currentCountry) {
        var path = window.location.pathname.toLowerCase();
        var nonUKPrefixes = ['/de', '/fr', '/es', '/nl', '/da', '/pt-br', '/pt-pt'];
        return nonUKPrefixes.some(function(prefix) {
            return path.startsWith(prefix + '/') || path === prefix;
        });
    }

    return currentCountry !== 'GB';
}

function injectExcludeIds(bodyObj) {
    if (!bodyObj || !bodyObj.recordQueries) return bodyObj;

    bodyObj.recordQueries.forEach(function(query) {
        if (query.settings) {
            if (!query.settings.excludeIds) {
                query.settings.excludeIds = [];
            }
            GIFT_CARD_EXCLUDE_IDS.forEach(function(id) {
                var exists = query.settings.excludeIds.some(function(existing) {
                    return existing.key === id.key && existing.value === id.value;
                });
                if (!exists) {
                    query.settings.excludeIds.push(id);
                }
            });
        }
    });

    return bodyObj;
}

/**
 * Intercept Klevu API requests to inject excludeIds for non-UK storefronts.
 * Checks currency/locale at request time (not setup time) and intercepts
 * both fetch and XMLHttpRequest to cover all Klevu SDK versions.
 */
(function() {
    // Intercept fetch
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
        if (isNonUKStorefront() && typeof url === 'string' && url.includes('klevu.com') && options && options.body) {
            try {
                var body = JSON.parse(options.body);
                injectExcludeIds(body);
                options = Object.assign({}, options, { body: JSON.stringify(body) });
            } catch (e) {
                // Parsing failed — let original request through
            }
        }
        return originalFetch.apply(this, arguments);
    };

    // Intercept XMLHttpRequest
    var originalXHRSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(data) {
        if (isNonUKStorefront() && this._klevuUrl && typeof this._klevuUrl === 'string' && this._klevuUrl.includes('klevu.com') && data) {
            try {
                var body = JSON.parse(data);
                injectExcludeIds(body);
                data = JSON.stringify(body);
            } catch (e) {
                // Parsing failed — let original request through
            }
        }
        return originalXHRSend.call(this, data);
    };

    var originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        this._klevuUrl = url;
        return originalXHROpen.apply(this, arguments);
    };
})();

klevu.beforeActivation("quick", function(data, scope){
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickProductsCustom, 'klevuQuickProducts', true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
    });
});

/**
 * Multi-currency: Track render generation to avoid stale price updates.
 */
var quickSearchPriceUpdateId = 0;

/**
 * Multi-currency: Cache of fetched prices by product handle.
 * Persists across renders so re-rendered products update instantly.
 */
var quickSearchPriceCache = {};

/**
 * Multi-currency: Update quick search prices for non-primary markets.
 * - Klevu only indexes GBP prices (primary market).
 * - For other currencies, fetch localized prices from Shopify's Liquid
 *   endpoint (products/{handle}?view=klevu) which respects storefront currency.
 * - Uses a cache so re-rendered products get instant updates without re-fetching.
 * - After all fetches complete, re-queries the DOM to avoid stale element references.
 */
function updateQuickSearchPrices() {
    var currentCurrency = window.theme?.currency;

    // Skip if on primary market (GB) or currency data unavailable
    if (!currentCurrency || currentCurrency === 'GBP') {
        return;
    }

    quickSearchPriceUpdateId++;
    var currentUpdateId = quickSearchPriceUpdateId;

    var root = window.theme?.routes?.normalisedRoot || '/';

    /**
     * Apply cached prices to all currently visible price elements.
     * Re-queries the DOM each time to avoid stale element references.
     */
    function applyCachedPrices() {
        var priceContainers = document.querySelectorAll('#klevuSearchingArea .klevuQuickProductPrice');
        priceContainers.forEach(function(priceEl) {
            var productLink = priceEl.closest('a[href*="/products/"]');
            if (!productLink) return;

            var href = productLink.getAttribute('href');
            var handleMatch = href.match(/\/products\/([^?#/]+)/);
            if (!handleMatch) return;

            var handle = handleMatch[1];
            if (quickSearchPriceCache[handle]) {
                priceEl.innerHTML = quickSearchPriceCache[handle];
                priceEl.style.opacity = '1';
            }
        });
    }

    // First, instantly apply any cached prices from previous fetches
    applyCachedPrices();

    // Collect handles that still need fetching
    var priceContainers = document.querySelectorAll('#klevuSearchingArea .klevuQuickProductPrice');
    var handlesToFetch = [];

    priceContainers.forEach(function(priceEl) {
        var productLink = priceEl.closest('a[href*="/products/"]');
        if (!productLink) return;

        var href = productLink.getAttribute('href');
        var handleMatch = href.match(/\/products\/([^?#/]+)/);
        if (!handleMatch) return;

        var handle = handleMatch[1];

        // Skip if already cached
        if (quickSearchPriceCache[handle]) return;

        // Show loading state
        priceEl.style.opacity = '0.5';

        if (handlesToFetch.indexOf(handle) === -1) {
            handlesToFetch.push(handle);
        }
    });

    if (!handlesToFetch.length) return;

    // Fetch all uncached prices in parallel
    var fetchPromises = handlesToFetch.map(function(handle) {
        return fetch(root + 'products/' + handle + '?view=klevu')
            .then(function(response) {
                if (!response.ok) throw new Error('Failed to fetch price for ' + handle);
                return response.json();
            })
            .then(function(data) {
                if (data.price) {
                    quickSearchPriceCache[handle] = data.price;
                }
            })
            .catch(function(err) {
                console.warn('Klevu price fetch failed for:', handle, err);
            });
    });

    // After ALL fetches complete, re-query DOM and apply prices
    Promise.all(fetchPromises).then(function() {
        // Only apply if this is still the latest render generation
        if (currentUpdateId !== quickSearchPriceUpdateId) return;
        applyCachedPrices();

        // Reset opacity for any products that failed to fetch
        var remaining = document.querySelectorAll('#klevuSearchingArea .klevuQuickProductPrice');
        remaining.forEach(function(priceEl) {
            if (priceEl.style.opacity === '0.5') {
                priceEl.style.opacity = '1';
            }
        });
    });
}

klevu.afterTemplateRender('quick', function (data, scope) {

    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);

    /**
     * Multi-currency: Fetch and display localized prices for non-primary markets.
     */
    updateQuickSearchPrices();

    /**
     * Gift Card Exclusion: Remove Digital Gift Card from rendered results
     * for non-UK storefronts. This is a DOM-level filter that works
     * regardless of how Klevu sends its API requests.
     */
    if (isNonUKStorefront()) {
        var marketRestrictedHandles = [
            'borough-kitchen-e-gift-card',
            'borough-kitchen-paper-gift-card'
        ];

        marketRestrictedHandles.forEach(function(handle) {
            // Remove from product list results
            var productItems = document.querySelectorAll('#klevuSearchingArea .klevuProduct, #klevuSearchingArea .klevuQuickProductInnerBlock');
            productItems.forEach(function(item) {
                var link = item.closest('li') || item.closest('a');
                if (!link) link = item;
                var anchor = link.querySelector('a[href]') || link;
                var href = anchor.getAttribute('href') || '';
                if (href.indexOf('/products/' + handle) !== -1) {
                    var listItem = item.closest('li') || item.closest('.klevuQuickProductInnerBlock')?.parentElement || item;
                    listItem.style.display = 'none';
                }
            });

            // Also check trending/personalization product blocks
            var allLinks = document.querySelectorAll('#klevuSearchingArea a[href*="/products/' + handle + '"]');
            allLinks.forEach(function(link) {
                var container = link.closest('li') || link.parentElement;
                if (container) {
                    container.style.display = 'none';
                }
            });
        });
    }

});
klevu.support.hook(['recs'], function() {
    klevu({
      powerUp: {
        catnav: true,
        landing: true,
      },
    });
  });
});

/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
    if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
        updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
    }
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
    </div>
</div>
<div class="klevuProductItemBottom">
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("FROM")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickProductsCustom = `
<% if(data.query.productList) { %>
    <% if(data.query.productList.result.length > 0 ) { %>
        <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content" data-content="productList" >
            <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                data-container-role="left">
                <div ku-block data-block-id="ku_quick_left_facets">
                    <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                    <% if(isQuickFiltersOnLeft === true && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                        <div data-section="productList" class="klevuMeta">
                            <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                        </div>                        
                    <% } %>
                </div>
                <div ku-block data-block-id="ku_quick_left_call_outs"></div>
                <div ku-block data-block-id="ku_quick_left_banner"></div>
            </section>
            <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                data-container-role="center">
                <header ku-block data-block-id="ku_quick_result_header"></header>
                <div ku-block data-block-id="ku_quick_result_items">
                    <div class="klevuResultsBlock">                            
                        <%=helper.render('klevuQuickProductBlockTitleHeader',scope,data) %>
                        <div class="klevuQuickSearchResults klevuMeta productList" data-section="productList" id="productList" data-result-view="list" >
                            <div class="kuQuickResultsListHeader">
                                <%=helper.render('kuTemplateQuickResultsViewSwitch',scope,data,"productList") %>
                                <%=helper.render('klevuQuickTemplateSortBy',scope,data,"productList") %>                                        
                            </div>
                            <div class="kuClearBoth"></div>
                            <div class="kuQuickResultsListContainer">
                                <ul>
                                    <% helper.each(data.query.productList.result,function(key,product){ %>
                                        <%=helper.render('klevuQuickProductBlock',scope,data,product) %>
                                    <% }); %>
                                    <%=helper.render('klevuQuickTemplateInfiniteScrollDown',scope,data) %>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div ku-block data-block-id="ku_quick_other_items">
                    <div data-section="productList" class="klevuMeta">
                        <%=helper.render('klevuQuickTemplatePagination',scope,data,"productList") %>
                    </div>
                </div>
                <footer ku-block data-block-id="ku_quick_result_footer">
                    <div class="klevuProductsViewAll">
                        <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
                        <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>"
                            target="_parent"><span><%=helper.translate("View All Results")%></span>
                        </a>
                    </div>
                </footer>
            </section>
            <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                data-container-role="right">
                <div ku-block data-block-id="ku_quick_right_facets">
                    <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                    <% if(isQuickFiltersOnLeft === false && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                        <div data-section="productList" class="klevuMeta">
                            <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                        </div>                        
                    <% } %>
                </div>
                <div ku-block data-block-id="ku_quick_right_call_outs"></div>
                <div ku-block data-block-id="ku_quick_right_banner"></div>
            </section>
        </div>
    <% } else { %>
        <% var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); %>
        <% if(isCmsEnabled) { %>
            <% if(data.query.cmsCompressed && data.query.cmsCompressed.result.length <= 0 ){ %>
                <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                        data-container-role="left">
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                        data-container-role="center">
                        <div ku-block data-block-id="ku_quick_no_result_items">
                            <%=helper.render('noResultsFoundQuick',scope) %>
                        </div>
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                        data-container-role="right">
                    </section>
                </div>
            <% } %>
        <% } else { %>
            <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                    data-container-role="left">
                </section>
                <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                    data-container-role="center">
                    <div ku-block data-block-id="ku_quick_no_result_items">
                        <%=helper.render('noResultsFoundQuick',scope) %>
                    </div>
                </section>
                <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                    data-container-role="right">
                </section>
            </div>
        <% } %>
    <% } %>
<% } else { %>        
<% } %>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <%= helper.render('customBlockTopOuter',scope) %>
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <%= helper.render('customBlockTop',scope) %>
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
            
            <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                <% if(quickFacetedLayoutMessage != "") { %>
                    <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                <% } %>                    
            <% } else { %>
                <% if(data.query.productList) { %>
                    <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                    <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                    <%= helper.render('klevuQuickProducts',scope) %>
                    <%= helper.render('klevuQuickOtherContent',scope) %>
                <% } else { %>              
                    <div class="kuSearchPersonalizationsContainer">
                        <%= helper.render('klevuSearchPersonalizations',scope) %>    
                    </div>
                <% } %>  
            <% } %>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
            <%= helper.render('customBlockBottom',scope) %>
        </div>
    </div>
</div>`;

const klevuQuickProductBlockCustom  = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                </div>
        </div>
        <div class="klevuProductItemBottom">
            <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                <div class="klevu-brand"><%= dataLocal.brand %></div>
            <% } %>
            <div class="klevuQuickProductDescBlock">
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("FROM")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;